module.exports = __webpack_public_path__ + "static/media/Home Page_website-06.01255b76.png";